type PlantRow = { type?: string; materialOrder?: { plantStatus?: string | null } | null };

/** Filter the grid's rows only; other consumers retain the unmodified cancellation data. */
export function plantVisibleRows<Row extends PlantRow>(rows: Row[], hasPlantRight: boolean): Row[] {
  if (!hasPlantRight) return rows;
  return rows.filter((row) => row.type === "external" || row.type === "manual" || row.materialOrder?.plantStatus !== "DELETED");
}
